var _circle, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFacebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.4286,
    cy: 44.4286,
    r: 44.4286,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.92773,
    y: 4.85211,
    width: 78,
    height: 78,
    rx: 39,
    fill: "#0B84EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1588 44.5635H55.4171L56.5567 37.1452H48.1574V33.0907C48.1574 30.009 49.1582 27.2764 52.0234 27.2764H56.6275V20.8026C55.8186 20.6927 54.1077 20.4521 50.875 20.4521C44.1245 20.4521 40.1669 24.0387 40.1669 32.21V37.1452H33.2275V44.5635H40.1669V64.9531C41.5412 65.161 42.9333 65.3021 44.3622 65.3021C45.6538 65.3021 46.9144 65.1833 48.1588 65.014V44.5635Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebook);
export default __webpack_public_path__ + "static/media/ic_facebook.731f9858acf37ed51c6e7515e63b827d.svg";
export { ForwardRef as ReactComponent };